export enum ContactsRoutes {
  root = 'contacts',
  all = 'all',
  cleanup = 'cleanup',
  history = 'history',
  duplicate = 'duplicate',
  unlinked = 'unlinked',
}
